import { Hearing } from '@enview/interface/types/bills/Bill';
import React, { useMemo } from 'react';
import { convertIdToAbbreviatedTitle } from '../../../helpers/BillHelper';
import RelatedBillPill from './RelatedBillPill';
import './Hearings.scss';
import { BillAPI } from '../../../api';
interface HearingRelatedBillsProps {
  hearing: Hearing;
}

export const HearingRelatedBills: React.FC<HearingRelatedBillsProps> = ({
  hearing,
}) => {
  const relatedBills =
    hearing.relatedBills?.map((bill) => {
      const abbrTitle = convertIdToAbbreviatedTitle(bill.id);
      return {
        id: bill.id,
        abbrTitle,
      };
    }) ?? [];

  const { data: trackedBills } = BillAPI.endpoints.getTrackedBills.useQuery(undefined);

  const trackedBillIds = useMemo(
    () => new Set(trackedBills?.map((b) => b.id) ?? []),
    [trackedBills],
  );

  return (
    <div
      className="hearings-bills"
      onClick={(e: React.SyntheticEvent) => e.stopPropagation()}
    >
      {relatedBills.map((relatedBill, index) => (
        <RelatedBillPill
          isTracked={trackedBillIds.has(relatedBill.id)}
          key={`related-bill-pill ${index}`}
          relatedBill={relatedBill}
        />
      ))}
    </div>
  );
};

export default HearingRelatedBills;
